import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { APIService } from 'src/app/api.service';
import { DataService } from '../../services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, AfterViewInit {

  jarvisData: any = [];
  agencyData: any = [];

  prTypeID: number = 1;
  modalReference: any;
  closeResult: any;
  modalStage: any;
  changingValue: Subject<boolean> = new Subject();
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.newStageList, event.previousIndex, event.currentIndex);
    for(let j = 0; j < this.newStageList.length; j++){
      this.newStageList[j].Seq = j + 1;
    }
  }
  prntCnfgMdlRef: any;
  prtCnfg: { jobInst: boolean, itemDesc: boolean } = {
    jobInst: false,
    itemDesc: false
  }
  @ViewChild('prntCnfgMdl', { static: false }) prntCnfgMdl!: ElementRef;
  @ViewChild('AddStageFlowMdl') addStageFlowRef!: TemplateRef<any>;

  stgFlowList: any = [];
  stgFlowName: string = "";
  originalStageList: any = [];
  stgFlowDataBeforeUpdate: any = [];
  stageList: any = [];
  newStageList: any = [];
  stageName: string = "";
  stgActionType: number = 1;
  isAdd: boolean = true;
  stgFlowActionType: string = "";

  

  constructor( private apiService: APIService, private dataSer: DataService, private router: Router, private modalService: NgbModal, private spinnerService: NgxSpinnerService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    // this.dataSer.projectData.subscribe((value: any) => {
    //   debugger
    //   if(value.prTypeID != '' && value.prTypeID != undefined){
    //     this.prTypeID = value.prTypeID;
    //   }
    // });
    let selectPrID = this.apiService.getCookie("prTypeID");
    if(selectPrID == '2'){
      this.prTypeID = 2
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let erpCfgCookie = this.apiService.getCookie('ERP_Cfg');
    if(erpCfgCookie) {
      let parsedCfgCookie = JSON.parse(erpCfgCookie);
      if(parsedCfgCookie && parsedCfgCookie.length > 0) {
        this.originalStageList = JSON.parse(parsedCfgCookie[0].PrdJobStages)
        this.stageList = this.originalStageList;
        if(parsedCfgCookie[0].PrtCfg) {
          let prtCnfg = JSON.parse(parsedCfgCookie[0].PrtCfg);
          if(prtCnfg && prtCnfg.length > 0) {
            this.prtCnfg.jobInst = prtCnfg[0].jobInst ? prtCnfg[0].jobInst : false;
            this.prtCnfg.itemDesc = prtCnfg[0].itemDesc ? prtCnfg[0].itemDesc : false;
          }
        }
      }
    }

    // Stage flow cookie
    let stgFlwCookie = this.apiService.getCookie("StgFlw");
    if(stgFlwCookie) {
      let parsedStgFlwCookie = JSON.parse(stgFlwCookie);
      if(parsedStgFlwCookie && parsedStgFlwCookie.length > 0) {
        this.stgFlowList = parsedStgFlwCookie;
      }
    }
    else {
      this.getValMethod("STGFLW");
    }
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['p'] == '1') {
        setTimeout(() => {
          this.openAddStageFlow(this.addStageFlowRef);
        }, 100);
      }

      if (params['j'] == '1' && this.prTypeID == 1) {
        setTimeout(() => {
          this.openPrntCnfgMdl('prntCnfgMdl');
        }, 120);
      }
    });
  }
  

  backBtn() {
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP"
    }
    if(this.prTypeID == 1){
      urlCheck += "/ProductionList?p=1"
    }
    else{
      urlCheck += "/Projects?p=2"
    }
    
    window.open(urlCheck, "_self");
    //window.history.back();
    // window.location.href="/"
    // window.history.back();
  }

  // openMdl() - open modal
  openMdl(content: any, mdlType: string) { 
    let wndwCls = "ValuationModal";
    if (mdlType == "stageFlow") {
      wndwCls = 'stageFlowMdl';
    }

    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: wndwCls, backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  public closeModal($event: any) {
    this.stgActionType = 1;
    this.resetStageFlow();
      this.modalReference.close();
      if ($event) {
          this.changingValue.next($event);
      }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
    } else {
        return `with: ${reason}`;
    }
  }

  // open() - open edit unit and add new unit modal 
  openAddStageFlow(content: any) { 
    this.resetStageFlow();
    this.modalStage = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'stageFlowMdl', backdrop: 'static', keyboard: false });
      this.modalStage.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      this.stgActionType = 2;
  }

  // resetStageFlow - reset stage flow
  resetStageFlow() {
    this.stgFlowName = "";
    this.stageList = this.originalStageList;
    this.newStageList = [];
  }

  closeStageModal() {
    this.modalStage.close();
  }


  // addNewStage - add new stage
  addNewStage(event: Event){
    let selectElement = event.target as HTMLSelectElement;
    this.stageName = selectElement.value;
    
    if(!this.stageName){
      return;
    }

    let tempStageList = this.stageList;
    let tempStage = tempStageList.filter((element: any, index: any) => {
      return (element.SNm == this.stageName);
    });

    if (tempStage.length == 0) {
      return;
    }

    this.stageList = this.stageList.filter((element: any) => element.SNm !== this.stageName);
    
    this.newStageList.push({
      SID: tempStage[0].SID,
      SNm: tempStage[0].SNm,
      UIDs: tempStage[0].UIDs,
      TID: tempStage[0].TID
    });

    this.stageName = "";
  }

  // removeStage - remove stage
  removeStage(ind: any){
    if(ind < 0){
      return;
    }

    let removedStage = this.newStageList.splice(ind, 1)[0];

    let tempStage = this.originalStageList.filter((element: any, index: any) => {
      return (element.SID == removedStage.SID);
    });

    if(tempStage.length == 0){
      return;
    }

    this.stageList.push(tempStage[0]);
    this.stageName = "";
  }

  // changeStgActionType - change stage action type
  changeStgActionType (id: number){
    if(id == 1 || id == 2){
      this.stgActionType = id;
      this.isAdd = true;
      this.resetStageFlow();
    }
  }

  // saveStageFlow - save stage flow
  saveStageFlow () {
    this.stgFlowName = this.stgFlowName.trim(); 
    let isDuplicate = false;
    if (!this.stgFlowName) {
      this.apiService.successAlert("Please enter stage flow name.");
      return;
    }

    isDuplicate = this.stgFlowList.some(
      (element: any) => element.StageFlow.toUpperCase() === this.stgFlowName.toUpperCase() &&
      (this.isAdd || element.StageFlowID !== this.stgFlowDataBeforeUpdate.StageFlowID)
    );


    if (isDuplicate) {
      this.apiService.successAlert("Stage flow name already exists.");
      return;
    }


    if (this.newStageList.length == 0) {
      this.apiService.successAlert("Please add stages to stage flow.");
      return;
    }
    
    this.newStageList.forEach((obj: any, index: any) => {
      obj.Seq = index + 1; // Assign sequence starting from 1
    });
    this.saveStageFlowDataToDB(this.stgFlowName, this.newStageList, this.isAdd ? "ADD" : "UPDATE");

  }

  // saveStageFlowDataToDB - save stage flow data to database
  saveStageFlowDataToDB(stageFlowName: string, stageFlowData: any,stgFlowActionType: string) {
    this.stgFlowActionType = stgFlowActionType
    let stgFlwChngType = "";

    switch (this.stgFlowActionType) {
      case "ADD":
      stgFlwChngType = "STAGEFLOWADD";
      break;
      case "UPDATE":
      stgFlwChngType = "STAGEFLOWUPDT";
      break;
      case "DELETE":
      stgFlwChngType = "STAGEFLOWDLT";
      break;
      default:
      this.apiService.successAlert("Invalid action type.");
      return;
    }

    
    let myLastSyncDT = localStorage.getItem("MyLastSyncDT");
    var tempData = [{
      'ChangeType': stgFlwChngType,
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod': 0,
      'PrdRejnReasons': '',
      'stgFlowID': this.stgFlowDataBeforeUpdate.StageFlowID ? this.stgFlowDataBeforeUpdate.StageFlowID : 0,
      'stgFlowName': stageFlowName,
      'stgFlowData': JSON.stringify(stageFlowData),
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: myLastSyncDT,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
    this.spinnerService.show();
    this.apiService.sendChange(myParams, this.successStageEntry.bind(this), this.failureStageResp.bind(this));
  }

  

  // failureResp - failure handler
  failureStageResp(res: any) {
    this.spinnerService.hide();
    if (!res.error) {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successStageEntry(res: any) {
    this.spinnerService.hide();
    if (!res.error) {
        if (!res) {
          return;
        }
        var reponseData = JSON.parse(res.updatePackage);
        if(reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let succErrMsg = "";
          if (this.stgFlowActionType == "ADD") {
            succErrMsg = "added";
          }
          else if (this.stgFlowActionType == "UPDATE") {
            succErrMsg = "updated";
          }
          else if (this.stgFlowActionType == "DELETE") {
            succErrMsg = "deleted";
          }

          this.apiService.successAlert("Stage flow " + succErrMsg + ".");
          if(this.modalStage) {
            this.modalStage.close('Done');
            this.resetStageFlow();
            this.stgActionType = 1
            this.getValMethod("STGFLW");
          }
        }
    }
  }

  // removeStageFlow - remove stage flow
  removeStageFlow(ind: any){
    var r = confirm("Are you sure you want to delete this StageFlow?");
    if(r == false) {
      return;
    }
    this.stgFlowDataBeforeUpdate = this.stgFlowList[ind];
    this.saveStageFlowDataToDB(this.stgFlowList[ind].StageFlow, [], "DELETE");
  }

  // editStageFlow - edit stage flow
  editStageFlow(content: any, ind: any){
    this.stgFlowDataBeforeUpdate  = this.stgFlowList[ind];
    this.stgFlowName = this.stgFlowList[ind].StageFlow;
    this.newStageList = JSON.parse(this.stgFlowList[ind].Stages);
    this.stageList = this.originalStageList.filter( (originalStage:any) => 
      !this.newStageList.some( (newStage:any) => newStage.SID === originalStage.SID)
    );
    // this.stgActionType = 2;
    this.isAdd = false;

    this.modalStage = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'stageFlowMdl', backdrop: 'static', keyboard: false });
  }

  // getUnits() - get all units from database
  getValMethod(callType: string = "") {
    var tempData = [{
      'changeType': 'STAGEFLOW',
    }];
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: callType == "STGFLW" ? JSON.stringify(tempData) : ""
    }];
    this.spinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      this.spinnerService.hide();  
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table4) {
                this.apiService.setCookie("StgFlw", JSON.stringify(reponseData.Table4));
                this.stgFlowList = reponseData.Table4;
            }
          }
      }
    }
  openPrntCnfgMdl(content: any) {
    if(this.prntCnfgMdl){
      const content = this.prntCnfgMdl.nativeElement;
      this.prntCnfgMdlRef = this.modalService.open(this.prntCnfgMdl, {ariaLabelledBy: 'tsk-done-modal', backdrop: 'static', keyboard: false, windowClass: 'taskDoneModal' });
      this.prntCnfgMdlRef.componentInstance.content = content;
    }
  }

  closePrntCnfModal() {
    this.prntCnfgMdlRef.close();
  }
  savePrntCnfg(){
    let temp = [];
    temp.push(this.prtCnfg);
    var tempData = [{
        'ChangeType': 'PRNTCFG',
        'GSTLdgrs':'',
        'Units': '',
        'Stores':'',
        'ItemCategories': '',
        'PrdJobStages': '',
        'ValnMethod': 0,
        'PrdRejnReasons': '',
        'stgFlowID': 0,
        'stgFlowName': '',
        'stgFlowData': '',
        'PrtCfg': JSON.stringify(temp)  
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
	this.spinnerService.show();
    this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

  successEntry(res: any) {
	this.spinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table2) {
          let cookieData2 = [];
          cookieData2.push(ErpData.Table2[0]);
          let ErpCfgData = JSON.stringify(cookieData2);
          localStorage.setItem("ERP_Cfg", ErpCfgData);
          this.apiService.successAlert("Job card print configuration saved successfully.");
        }
      }   
      this.prntCnfgMdlRef.close();
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.spinnerService.hide();
    if (res.error) {
    }
  }

}
